import React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import DetailsIcon from '@mui/icons-material/Launch';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {useNavigate} from 'react-router-dom';

import AvailabilityListItem from '../availabilities/AvailabilityListItem';

const ProviderAvailabilitySummary = ({
  availability,
  onClose
}) => {
  const navigate = useNavigate();
  return (
    <Box style={{zIndex: 10}}>
      <Stack spacing={1}>
        <AvailabilityListItem availability={availability} />
      </Stack>
      <Stack direction='row' justifyContent={onClose ? 'space-between' : 'flex-end'}>
        {onClose && 
          <Button 
            size='small'
            color='primary'
            startIcon={<CloseIcon />}
            onClick={e => onClose(e)}
          >
            Close
          </Button>}
        <Button size='small' startIcon={<DetailsIcon />} onClick={() => navigate(`/providers/availabilities/list`)}>
          View
        </Button>
      </Stack>
    </Box>
  );
};

export default ProviderAvailabilitySummary;